import isSameCompany from "../functions/isSameCompany";
import useSingleConfirmedRoute from "@Route/hooks/useSingleConfirmedRoute";

/**
 * Checks if single selected route company === route company
 * @param route {object}
 */
export default function useIsSameCompany(route) {
    const singleConfirmedRoute = useSingleConfirmedRoute()

    return isSameCompany({
        selectedSingleRouteCompanyId: singleConfirmedRoute?.companyId,
        routeCompanyId: route.companyId,
        isReturn: route.status.isReturn,
        routeId: route.id,
        singleConfirmedRouteId: singleConfirmedRoute?.id,
    })
}